'use client';

import { OverlayProvider as OverlayKitProvider } from 'overlay-kit';
export const OverlayProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <OverlayKitProvider data-sentry-element="OverlayKitProvider" data-sentry-component="OverlayProvider" data-sentry-source-file="OverlayProvider.tsx">{children}</OverlayKitProvider>;
};